(function() {
    var KRP0013 = {
        init: function() {
            var self = this;
            self.setting();
            self.bindEvents(); // BTOCSITE-57019
            self.bindPopupEvents();
            self.popupPackageModelEvents(); // BTOCSITE-44357
            if(typeof smartHome !== 'undefined'){
                if(smartHome) {
                    smartHome.smartHomeSupport();
                    if(digitalData.productInfo.smart_home_flag ==="N"){
                        smartHome.smartComponentArea();
                    }
                }
            }
        },

        setting: function() {
            var self = this;
            //콤포넌트
            self.$component = $('section.component.KRP0013');
            self.$packageButton = self.$component.find('.support-box .list-box a');
            self.$chatbotMktLink = self.$component.find('.product-support-chat a.item-buy-rental');
            self.$chatbotCsLink = self.$component.find('.product-support-chat a.customer-chat');
            self.$bridzCsLink = self.$component.find('#bridzCategoryProductSupport a'); //BTOCSITE-42269

            // BTOCSITE-57019 START
            //manual-section
            self.$manualSec = $('#manualSection');
            self.$btnMoreViewList = $('.btn-moreview');

            self.manualUrl = self.$manualSec.data('manualUrl');
            // BTOCSITE-57019 END

        },

        // BTOCSITE-57019 START
        searchAllList: function() {
            var self = this;
            //let languageValue = self.getLanguageValue();

            var modelPackageFlag = $('#modelPackageFlag').val();
            if (modelPackageFlag == 'Y') {
                //productCodeValue = $('.product-support-box  .tabs-wrap.ui_tab .on span.sub-text').text();
                let totalSetModel = self.getTotalSetModel();

                for (let i = 0; i < totalSetModel; i++) {
                    self.manualParam = $.extend(self.manualParam, {
                        category:      $('#category' + (i + 1)).val(),
                        categoryNm:    $('#categoryNm' + (i + 1)).val(), 
                        subCategory:   $('#subCategory' + (i + 1)).val(),
                        subCategoryNm: $('#subCategoryNm' + (i + 1)).val(), 
                        modelCode:     $('#modelCode' + (i + 1)).val(),
                        productCode:   $('#productCode' + (i + 1)).val(),
                        language_list : '', // search both KR and EN
                        type: 'manual',
                        page: 1
                    });
                    self.searchManualList(i + 1, false);
                }

            } else {
                self.manualParam = $.extend(self.manualParam, {
                    category:      $('#category').val(),
                    categoryNm:    $('#categoryNm').val(), 
                    subCategory:   $('#subCategory').val(),
                    subCategoryNm: $('#subCategoryNm').val(), 
                    modelCode:     $('#modelCode').val(),
                    productCode:   $('#productCode').val(),
                    language_list : '', // search both KR and EN
                    type: 'manual',
                    page: 1
                });
                self.searchManualList(1, false);
            }

        },

        getTotalSetModel: function() {
            return $('div.support-download.product-support-box > div.tabs-wrap.ui_tab > ul li').length;
        },

        searchManualList: function(indexRender, isForLoadMore, isActivedLoading) {
            var self = this;

            if (isActivedLoading) { //BTOCSITE-93863 PDP 화면 깜빡임 오류 수정
                lgkorUI.showLoading();
            }
            lgkorUI.requestAjaxData(self.manualUrl, self.manualParam, function(result){
                self.setManualList(result.data.manual, indexRender, isForLoadMore);
                lgkorUI.hideLoading();
            },'GET'); // BTOCSITE-31644 고객지원 > 검색엔진 성능 향상/고객지원 페이지 내 검색 기능 수정 요청
        },

        setManualList: function(data, indexRender, isForLoadMore) {
            var self = this;

            var manualListTemplate = 
            '<li {{#if typeof seq != "undefined"}}data-seq="{{seq}}"{{/if}} {{#if typeof language_list != "undefined"}}data-language="{{language_list}}"{{/if}} {{#if typeof date != "undefined"}}data-date="{{date}}"{{/if}} {{#if typeof fileId != "undefined"}}data-file-id="{{fileId}}"{{/if}}>' +
                '<div class="top-area">' +
                    '<strong>{{type}}</strong>' +
                    '<p>{{title}}</p>' +
                '</div>' +
                '<div class="bottom-area">' +
                    '{{# if (typeof language != "undefined" || typeof date != "undefined" || typeof os != "undefined" || language != "" || date !="" || os != "") { #}}' +
                    '<div class="sub-text-wrap">' +
                        '{{# if (typeof language != "undefined" || language != "") { #}}' +
                            '<span>{{language}}</span>' +
                        '{{# } #}}' +
                        '{{# if (typeof date != "undefined" || date != "") { #}}' +
                            '<span>{{date}}</span>' +
                        '{{# } #}}' +
                        '{{# if (os != "") { #}}' +
                            '<span>OS</span>' +
                        '{{# } #}}' +
                        '{{# if (os != "") { #}}' +
                            '<span>{{os}}</span>' +
                        '{{# } #}}' +
                    '</div>' +
                    '{{# } #}}' +
                    '<div class="btn-group">' +
                        '{{# for (var i = 0; i < file.length; i++) { #}}' +
                            '{{# if (i == 0) { #}}' +
                                '<a href="{{file[i].src}}" target="_blank" type="button" class="btn-download" data-type="{{file[i].type}}" data-app-target="out" ><span>{{file[i].str}}</span></a>' +
                            '{{# } #}}' +
                            '{{# if (i == 1) { #}}' +
                                '<a href="{{file[i].src}}" target="_blank" type="button" class="btn-view" data-type="{{file[i].type}}" data-app-target="out" title="새창열림"><span>{{file[i].str}}</span></a>' + // BTOCSITE-81509 [웹앱 접근성 개선활동] PDP - 일반, 케어용품/소모품:title 추가
                            '{{# } #}}' +
                        '{{# } #}}' +
                    '</div>' +
                '</div>' +
            '</li>';

            var $listWrap = self.$manualSec.find('.tabs-contant');
                //$noData = self.$manualSec.find('.no-data');
            var listArr = data.listData instanceof Array ? data.listData : [];
            var page = data.listPage;
            var html = "";

            var modelPackageFlag = $('#modelPackageFlag').val();
            let productCodeValue;

            if (page.totalCount > 0) {
                if (modelPackageFlag == "Y") {

                    productCodeValue = $('.product-support-box  .tabs-wrap.ui_tab .on span.sub-text').text();

                    let indexPickup = 0;
                    $('[id^="modelCode"]').each(function() { // modelCodes input hidden
                        if (productCodeValue == $(this).val()) {

                            $('div[id^="download01_' + (indexPickup + 1) + '"]').css('display', 'block');
                            $('div[id^="download01_' + (indexPickup + 1) + '"]').attr('aria-hidden', 'false');

                            return false;
                        }
                        indexPickup++;
                    });

                } else {
                    $('div[id^="download01_1"]').css('display', 'block');
                    $('div[id^="download01_1"]').attr('aria-hidden', 'false');
                }
            }

            let indexCountLoop = 0;
            if (page.view == 'N') {
                if (modelPackageFlag == 'N') {
                    $('.btn-moreview').hide();
                } else {
                    $('.btn-moreview').each(function() {
                        if (indexRender == (indexCountLoop + 1)) {
                            $($('.btn-moreview').get(indexCountLoop)).hide();
                            return false;
                        }
                        indexCountLoop++;
                    });
                }
            } else {
                if (modelPackageFlag == 'N') {
                    $('.btn-moreview').show();
                } else {
                    $('.btn-moreview').each(function() {
                        if (indexRender == (indexCountLoop + 1)) {
                            $($('.btn-moreview').get(indexCountLoop)).show();
                            return false;
                        }
                        indexCountLoop++;
                    });
                }
            }

            if (listArr.length) {
                listArr.forEach(function(item) {
                    // BTOCSITE-31495 H&A 제품 사용 설명서 호출 시 유입 경로 파악을 위한 UTM 정보 삽입 요청
                    self.salesCodeForUTM = item.sales_model_cd; //세일즈코드 for utm
                    
                    var fileList = [];
                    item.file.forEach(function(item2){
                        var obj={};
                        obj.src=item2.src
                        obj.type=item2.type
                        obj.str=(item2.type.toUpperCase()=="HTML")?"바로보기":"다운로드"      /* zip jslee */
                        fileList.push(obj);
                    });
                    item.file = fileList
                    
                    html += vcui.template(manualListTemplate, item);

                });

                if (modelPackageFlag == 'N') {
                    if ($('div[id="download01_1"] .download-list').length > 0) {
                        if (isForLoadMore) {
                            $('div[id="download01_1"] .download-list').append(html);
                        } else {
                            $('div[id="download01_1"] .download-list').html(html);
                        }
                    }
                } else {
                    if ($('div[id="download01_'+ indexRender +'"] .download-list').length > 0) {
                        if (isForLoadMore) {
                            $('div[id="download01_'+ indexRender +'"] .download-list').append(html);
                        } else {
                            $('div[id="download01_'+ indexRender +'"] .download-list').html(html);
                        }
                    }
                }

                $listWrap.show();

                // BTOCSITE-31495 H&A 제품 사용 설명서 호출 시 유입 경로 파악을 위한 UTM 정보 삽입 요청
                self.searchModelRDate(); // sales date
                
            } else {

                if (modelPackageFlag == 'N') {
                    if (isForLoadMore) {
                        $('.btn-moreview').hide();
                    } else {
                        $('div[id="download01_1"] .download-list').empty();
                        $listWrap.hide();
                    }
                } else {
                    if (isForLoadMore) {
                        let indexBtnMoreView = 0;
                        $('[id^="modelCode"]').each(function() { // modelCodes input hidden
                            if (productCodeValue == $(this).val()) {
                                return false;
                            }
                            indexBtnMoreView++;
                        });
                        $($('.btn-moreview').get(indexBtnMoreView)).hide();
                    } else {
                        $('div[id="download01_' + indexRender + '"] .download-list').empty();
                    }
                }
                
            }
        },

        onClickMoreViewAction: function() {
            var self = this;
            let language_val = self.getLanguageValue();

            var modelPackageFlag = $('#modelPackageFlag').val();
            var productCodeValue;
            if (modelPackageFlag == 'Y') {
                // which product in set-product was selected
                productCodeValue = $('.product-support-box  .tabs-wrap.ui_tab .on span.sub-text').text();
            } else {
                productCodeValue = $('#productCode').val();
            }

            let elementOnShow = $('div[id^="download01_"]').filter(function() {return $(this).css('display') !== 'none';});

            let currentPage = elementOnShow.data('page');
            if (!currentPage) {
                currentPage = 1;
            }
            currentPage++;
            elementOnShow.data('page', currentPage);
            
            if (modelPackageFlag == 'Y') {
                let indexPickup = 0;
                $('[id^="modelCode"]').each(function() { // modelCodes input hidden
                    if (productCodeValue == $(this).val()) {
                        return false;
                    }
                    indexPickup++;
                });
                self.manualParam = $.extend(self.manualParam, {
                    category:      $('#category' + (indexPickup + 1)).val(),
                    categoryNm:    $('#categoryNm' + (indexPickup + 1)).val(), 
                    subCategory:   $('#subCategory' + (indexPickup + 1)).val(),
                    subCategoryNm: $('#subCategoryNm' + (indexPickup + 1)).val(), 
                    modelCode:     $('#modelCode' + (indexPickup + 1)).val(),
                    productCode:   productCodeValue,
                    language_list : language_val,
                    type: 'manual',
                    page: currentPage
                });

                self.searchManualList(indexPickup + 1, true);

            } else {
                self.manualParam = $.extend(self.manualParam, {
                    category:      $('#category').val(),
                    categoryNm:    $('#categoryNm').val(), 
                    subCategory:   $('#subCategory').val(),
                    subCategoryNm: $('#subCategoryNm').val(), 
                    modelCode:     $('#modelCode').val(),
                    productCode:   productCodeValue,
                    language_list : language_val,
                    type: 'manual',
                    page: currentPage
                });

                self.searchManualList(1, true);
            }

            
        },
        
        setUTM: function(rdate){
            var self = this;
            var $list = self.$manualSec.find('.download-list');

            var arrBusiCode = ['CNZ', 'DFZ', 'DVZ', 'CVZ', 'DLZ', 'DMZ', 'DGZ', 'CDZ', 'ANZ', 'SIG', 'SAP']; // GA사업부코드
            var utm_source = isApp() ? 'app' : 'lgweb',
                utm_medium = 'dotcom',
                utm_campaign = 'base',
                model = self.salesCodeForUTM, // 세일즈 코드
                rdate = rdate ? rdate : '',
                htmlParam = '';
            
            htmlParam = "?utm_source="+utm_source+"&utm_medium="+utm_medium+"&utm_campaign="+utm_campaign+"&model="+model+"&rdate="+rdate;

            $list.find('>li').each(function(i) {
                var $this = $(this);

                $(this).find('a').each(function(index, item){
                    var itemHref = item.getAttribute('href');
                    var itemType = item.getAttribute('data-type');
                    var busiCode = itemHref.split('/')[3]; 

                    var isGscs = itemHref.includes('gscs-manual.lge.com');
                    var isBusiCode = arrBusiCode.includes(busiCode); //사업부 체크
                    var isParam = itemHref.indexOf('?') === -1;
                    
                    if(itemType == 'html' && isGscs && isBusiCode && isParam) {
                        item.setAttribute("href", itemHref + htmlParam);
                    }
                });
            });
        },
        // BTOCSITE-31495 H&A 제품 사용 설명서 호출 시 유입 경로 파악을 위한 UTM 정보 삽입 요청
        searchModelRDate: function(){
            var self = this;
            var ajaxUrl = '/support/manuals/searchModelRDate.lgajax';

            if(!lgkorUI.isLogin){
                self.setUTM();
            }else{
                // 메인, 상단 보유 제품 선택시
                if(!!$('#salesDateForUTM').val()){
                    self.setUTM($('#salesDateForUTM').val());
                }else{
                    lgkorUI.showLoading();
                    lgkorUI.requestAjaxDataPost(ajaxUrl, {'salesModelCd': self.salesCodeForUTM}, function(result){
                        var data = result.data == null ? '' : result.data.salesDt;
                        if(result.resultFlag == 'Y'){
                            self.setUTM(data); // sales date 가져와서 url에 UTM 정보 상입
                        }
                        lgkorUI.hideLoading();
                    });
                }
            }
        },

        bindEvents: function() {
            var self = this;
            self.$manualSec.find('#select-lang').on('change',function(e) {
                e.preventDefault();
                e.stopPropagation();
                let modelPackageFlag = $('#modelPackageFlag').val();
                let timeDelayForSync = 700;
                if (modelPackageFlag == 'Y') {
                    timeDelayForSync = 1300;
                }
                lgkorUI.showLoading();
                setTimeout(() => {
                    self.onChangeLanguageAction();
                }, timeDelayForSync); //delay for async selectbox changed
            });

            self.$btnMoreViewList.on('click',function(e) {
                e.preventDefault();
                e.stopPropagation();
                self.onClickMoreViewAction();
            });

            self.searchAllList();

        },

        onChangeLanguageAction: function() {
            var self = this;
            let language_val = self.getLanguageValue();
            $('div[id^="download01_"]').data('page', 1); // reset page count

            var modelPackageFlag = $('#modelPackageFlag').val();
            var productCodeValue;
            if (modelPackageFlag == 'Y') {
                let indexPickup = 0;
                $('div[id^="download01_"]').each(function() {
                    self.manualParam = $.extend(self.manualParam, {
                        category:      $('#category' + (indexPickup + 1)).val(),
                        categoryNm:    $('#categoryNm' + (indexPickup + 1)).val(), 
                        subCategory:   $('#subCategory' + (indexPickup + 1)).val(),
                        subCategoryNm: $('#subCategoryNm' + (indexPickup + 1)).val(), 
                        modelCode:     $('#modelCode' + (indexPickup + 1)).val(),
                        productCode:   $('#productCode' + (indexPickup + 1)).val(),
                        language_list : language_val,
                        type: 'manual',
                        page: 1
                    });
                    self.searchManualList(indexPickup + 1, false, true);

                    indexPickup++;
                });


            } else {
                productCodeValue = $('#productCode').val();
                self.manualParam = $.extend(self.manualParam, {
                    category:      $('#category').val(),
                    categoryNm:    $('#categoryNm').val(), 
                    subCategory:   $('#subCategory').val(),
                    subCategoryNm: $('#subCategoryNm').val(), 
                    modelCode:     $('#modelCode').val(),
                    productCode:   productCodeValue,
                    language_list : language_val,
                    type: 'manual',
                    page: 1
                });
                self.searchManualList(1, false, true);
            }
        },

        getLanguageValue: function() {
            let language_val = $('.support-link-wrap .ui-selectbox-view span.ui-select-text').text();
            if (language_val && language_val == 'English') {
                language_val = 'en';
            } else if (language_val && language_val == '한글') {
                language_val = 'kr';
            } else {
                language_val = '';
            }
            return language_val;
        },

        // BTOCSITE-57019 END

        //팝업 버튼 이벤트
        bindPopupEvents: function() {
            var self = this;
            //BTOCSITE-1376 사용설명서 팝업 열기
            self.$packageButton.off('click').on('click', function(e){

                var isBridz = self.$component.attr('data-bridz-category');

                if(isBridz =="Y"){
                    e.preventDefault();
                    var $this = $(this);
                    var target = $this.attr('data-target');
                    var url = $this.attr('data-link');

                    if(target !== undefined && target !==null && target !== 'undefined' && target == "_blank"){
                        window.open(url,target);
                    }else{
                        location.href = url;
                    }
                }else{
                    var $this = $(this);
                    if( $this.hasClass('package')) {
                        e.preventDefault();
                        var popupId = $this.attr('href');
                        $(popupId).vcModal({opener: this});
                    }
                }
            })
            //BTOCSITE-5938-250 [모니터링] KRP0008.js 렌탈 전화상담 예약 팝업과 중복 호출 오류로 닫기 기능 삭제

            // BTOCSITE-20351
            self.$chatbotMktLink.on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                lgkorUI.goChatbot(lgkorUI.CHATBOT_SERVICE_LIST[1]); // cs 챗봇
            });

            self.$chatbotCsLink.on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                lgkorUI.goChatbot(lgkorUI.CHATBOT_SERVICE_LIST[0]); // 마케팅 챗봇
            });

            //BTOCSITE-42269 Start
            self.$bridzCsLink.off('click').on('click', function(e) {
                e.preventDefault();
                var $this = $(this);
                var url = $this.attr('data-link');
                var target = $this.attr('data-target');
                if(target !== undefined && target !==null && target !== 'undefined' && target == "_blank"){
                    window.open(url,target);
                }
            });
            //BTOCSITE-42269 End
        },
        // BTOCSITE-44357 start
        popupPackageModelEvents: function() {
            $('.popup-package-model').find('.pop-footer .btn').on('click', function(e){
                var _self = this;
                var $targetPopup = $(this).closest('.popup-package-model')
                KRP0013.packageSelect(_self, $targetPopup)
            })
        },
        packageSelect: function(alertTarget, $targetPopup){
            var $radio = $targetPopup.find('.model-list input:radio');
            if( !$radio.filter(':checked').length ) {
                var msgTxt = '제품을 선택해주세요';
                lgkorUI.alert("", {title: msgTxt}, alertTarget);
            } else {
                location.href = $radio.filter(':checked').data('model-path');
            }
        },
        // BTOCSITE-44357 end
    };

    function funcReady() {
        $('.KRP0013').buildCommonUI();
        KRP0013.init();

        if (!vcui.detect.isMobileDevice) {//221130 모바일 디바이스가 아닌 경우 전화번호링크 안되도록
            $('.consulting-box a').each(function(){
                $(this).removeAttr('href');
            });
        }
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'CONTENTS', name: 'KRP0013', isFirstLoad: false, fn: function () {
                if(!document.querySelector('.KRP0013')) return false;
                funcReady();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(document).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRP0013')) return false;
        funcReady();
    });
})();